import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

const ServicesPage = () => {
  useEffect(() => {
    document.title = 'Vize Hizmetlerimiz | İzmir Vize Danışmanlığı';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İzmir vize danışmanlığı hizmetleri: Schengen, Amerika, İngiltere vizesi, oturum kartı, aile birleşimi ve e-vize başvuruları. 12 yıllık deneyim ile profesyonel destek.');
    }
  }, []);

  const services = [
    {
      title: 'Schengen Bölgesi C Tipi Vizeler',
      subtitle: 'Ticari, Turistik, Aile ve Arkadaş Ziyareti',
      description: 'Kısa süreli seyahatler için düzenlenmiş Schengen C tipi vizelerde, başvuru belgelerinin hazırlanması, randevu alınması ve evrakların kontrolünde kapsamlı destek sağlanır.',
      icon: 'ri-earth-line',
      features: ['Evrak hazırlığı', 'Randevu alımı', 'Başvuru takibi', 'Görüşme hazırlığı'],
      color: 'navy',
    },
    {
      title: 'Schengen Bölgesi D Tipi Vizeler',
      subtitle: 'Çalışma, Eğitim',
      description: 'Uzun süreli ikamet veya eğitim amaçlı vize başvurularında, resmi kurumlarla uyumlu şekilde tüm işlemleri eksiksiz yönetiyoruz.',
      icon: 'ri-briefcase-line',
      features: ['Çalışma izni', 'Öğrenci vizesi', 'Uzun dönem ikamet', 'Evrak kontrolü'],
      color: 'cream',
    },
    {
      title: 'Amerika Vizesi',
      subtitle: 'Turistik',
      description: 'ABD\'ye yapılacak kısa süreli seyahatlerde, DS-160 formu hazırlığı, randevu işlemleri ve görüşme öncesi bilgilendirme desteği sunulmaktadır.',
      icon: 'ri-flight-takeoff-line',
      features: ['DS-160 formu', 'Randevu sistemi', 'Görüşme koçluğu', 'Evrak danışmanlığı'],
      color: 'navy',
    },
    {
      title: 'İngiltere Vizesi',
      subtitle: 'Turistik',
      description: 'İngiltere vize başvurularında, evrak hazırlığı, dilekçe desteği ve başvuru merkezi yönlendirmesi konusunda profesyonel hizmet veriyoruz.',
      icon: 'ri-map-pin-line',
      features: ['Online başvuru', 'Evrak hazırlığı', 'Biyometrik randevu', 'Başvuru takibi'],
      color: 'cream',
    },
    {
      title: 'Oturum Kartı Başvuruları',
      subtitle: 'AB Ülkeleri',
      description: 'Avrupa Birliği ülkeleri başta olmak üzere çeşitli ülkelerde oturum kartı başvuruları ve ilk başvuru işlemlerinde danışmanlık.',
      icon: 'ri-home-line',
      features: ['İkamet izni', 'Çalışma izni', 'Aile ikamet izni', 'Süre uzatma'],
      color: 'navy',
    },
    {
      title: 'Göçmenlik ve Aile Birleşimi Süreçleri',
      subtitle: 'Kalıcı İkamet',
      description: 'Aile birleşimi, evlilik ve kalıcı göçmenlik başvurularında gerekli yasal düzenlemelerin tamamlanmasını sağlıyoruz.',
      icon: 'ri-group-line',
      features: ['Aile birleşimi', 'Evlilik vizesi', 'Kalıcı oturum', 'Vatandaşlık danışmanlığı'],
      color: 'cream',
    },
    {
      title: 'E-vizeler',
      subtitle: 'Hızlı İşlem',
      description: 'Dubai, Ermenistan, Kuveyt, Suudi Arabistan, Rusya, Vietnam, Küba için hızlı ve güvenilir e-vize hizmetleri sunuyoruz.',
      icon: 'ri-global-line',
      features: ['Hızlı işlem', 'Online başvuru', '7/24 destek', 'Anında onay'],
      color: 'navy',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        {/* Hero Section with Background */}
        <section className="relative py-10 md:py-20 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://public.readdy.ai/ai/img_res/dee61ff53581da0726cfeafb4e63cb90.jpg"
              alt="Services Background"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-navy-900/95 via-navy-900/90 to-navy-900/95"></div>
          </div>
          
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <span className="inline-block px-3 py-1.5 md:px-5 md:py-2 bg-cream-400 text-navy-900 text-xs font-semibold tracking-widest uppercase rounded-full mb-3 md:mb-5 shadow-xl">
              Hizmetlerimiz
            </span>
            <h1 className="font-display text-2xl md:text-4xl lg:text-5xl font-bold text-cream-100 mb-3 md:mb-5">
              İzmir Vize Danışmanlığı Hizmetleri
            </h1>
            <p className="text-cream-200 text-sm md:text-lg lg:text-xl max-w-4xl mx-auto leading-relaxed">
              12 yıllık deneyimimiz ile tüm vize türlerinde profesyonel destek sunuyoruz. 
              Schengen, Amerika, İngiltere vizesi ve daha fazlası için yanınızdayız.
            </p>
          </div>
        </section>

        {/* Services Grid - Modern Card Design */}
        <section className="py-8 md:py-16 bg-gradient-to-b from-white to-cream-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-3 md:gap-6">
              {services.map((service, index) => {
                const isNavy = service.color === 'navy';
                return (
                  <div
                    key={index}
                    className="group relative overflow-hidden rounded-xl md:rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-1"
                  >
                    {/* Background Gradient */}
                    <div className={`absolute inset-0 ${isNavy ? 'bg-gradient-to-br from-navy-900 to-navy-800' : 'bg-gradient-to-br from-cream-400 to-cream-300'}`}></div>
                    
                    {/* Decorative Pattern */}
                    <div className="absolute inset-0 opacity-10">
                      <div className="absolute inset-0" style={{
                        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
                        backgroundSize: '30px 30px'
                      }}></div>
                    </div>

                    {/* Content */}
                    <div className="relative p-4 md:p-8">
                      {/* Icon */}
                      <div className={`w-12 h-12 md:w-16 md:h-16 flex items-center justify-center ${isNavy ? 'bg-cream-400' : 'bg-navy-900'} rounded-lg md:rounded-xl mb-3 md:mb-5 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg`}>
                        <i className={`${service.icon} text-xl md:text-3xl ${isNavy ? 'text-navy-900' : 'text-cream-100'}`}></i>
                      </div>
                      
                      {/* Title & Subtitle */}
                      <h3 className={`font-display text-lg md:text-2xl font-bold ${isNavy ? 'text-cream-100' : 'text-navy-900'} mb-1`}>
                        {service.title}
                      </h3>
                      <p className={`text-xs md:text-sm font-semibold ${isNavy ? 'text-cream-300' : 'text-navy-700'} mb-3 md:mb-4 uppercase tracking-wide`}>
                        {service.subtitle}
                      </p>
                      
                      {/* Description */}
                      <p className={`${isNavy ? 'text-cream-200' : 'text-navy-600'} leading-relaxed mb-3 md:mb-6 text-xs md:text-base`}>
                        {service.description}
                      </p>
                      
                      {/* Features */}
                      <div className="grid grid-cols-2 gap-1.5 md:gap-3 mb-3 md:mb-6">
                        {service.features.map((feature, idx) => (
                          <div key={idx} className="flex items-center space-x-1.5 md:space-x-2">
                            <i className={`ri-checkbox-circle-fill ${isNavy ? 'text-cream-400' : 'text-navy-900'} text-sm md:text-lg`}></i>
                            <span className={`${isNavy ? 'text-cream-200' : 'text-navy-700'} text-xs md:text-sm font-medium`}>{feature}</span>
                          </div>
                        ))}
                      </div>
                      
                      {/* CTA Button */}
                      <a
                        href="https://wa.me/905514803007?text=Merhaba%20ben%20sizinle%20karsiyakavisaconsulting.com.tr%20sitesinden%20iletisime%20geciyorum"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`inline-flex items-center px-4 py-2 md:px-6 md:py-3 ${isNavy ? 'bg-cream-400 text-navy-900 hover:bg-cream-300' : 'bg-navy-900 text-cream-100 hover:bg-navy-800'} rounded-full font-bold text-xs md:text-base transition-all hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap`}
                      >
                        Hemen Başvur
                        <i className="ri-arrow-right-line ml-1.5 md:ml-2 text-base md:text-lg"></i>
                      </a>
                    </div>

                    {/* Hover Border Effect */}
                    <div className="absolute inset-0 border-4 border-transparent group-hover:border-white/20 rounded-xl md:rounded-2xl transition-all duration-500"></div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="relative py-8 md:py-16 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900"></div>
          
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-cream-400/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-cream-400/10 rounded-full blur-3xl"></div>

          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-6 md:mb-12">
              <span className="inline-block px-3 py-1.5 md:px-5 md:py-2 bg-cream-400/20 text-cream-100 text-xs font-semibold tracking-widest uppercase rounded-full mb-3 md:mb-4">
                Süreç
              </span>
              <h2 className="font-display text-2xl md:text-4xl lg:text-5xl font-bold text-cream-100 mb-2 md:mb-4">
                Başvuru Sürecimiz
              </h2>
              <p className="text-cream-300 text-sm md:text-lg max-w-3xl mx-auto">
                İzmir vize danışmanlığı süreciniz 4 basit adımda tamamlanır
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
              {[
                { step: '01', title: 'İletişim', desc: 'Bize ulaşın ve ihtiyacınızı belirtin', icon: 'ri-phone-line' },
                { step: '02', title: 'Danışmanlık', desc: 'Uzman ekibimiz size yol gösterir', icon: 'ri-user-star-line' },
                { step: '03', title: 'Evrak Hazırlığı', desc: 'Belgelerinizi hazırlayın', icon: 'ri-file-list-line' },
                { step: '04', title: 'Başvuru', desc: 'Başvurunuzu tamamlayın', icon: 'ri-checkbox-circle-line' },
              ].map((item, index) => (
                <div key={index} className="relative group">
                  <div className="bg-cream-400/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-3 md:p-6 border border-cream-400/20 hover:bg-cream-400/20 transition-all duration-500 hover:scale-105">
                    <div className="w-12 h-12 md:w-20 md:h-20 flex items-center justify-center bg-cream-400 rounded-lg md:rounded-xl mx-auto mb-2 md:mb-4 group-hover:rotate-6 transition-all duration-500 shadow-xl">
                      <i className={`${item.icon} text-2xl md:text-4xl text-navy-900`}></i>
                    </div>
                    <div className="font-display text-2xl md:text-5xl font-bold text-cream-400/20 mb-1 md:mb-3 text-center">
                      {item.step}
                    </div>
                    <h3 className="font-display text-sm md:text-xl font-bold text-cream-100 mb-1 md:mb-2 text-center">
                      {item.title}
                    </h3>
                    <p className="text-cream-300 text-center leading-relaxed text-xs md:text-sm">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-8 md:py-16 bg-gradient-to-b from-cream-50 to-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="font-display text-2xl md:text-4xl lg:text-5xl font-bold text-navy-900 mb-3 md:mb-6">
              Vize Başvurunuzu Başlatın
            </h2>
            <p className="text-navy-600 text-sm md:text-lg mb-4 md:mb-8 leading-relaxed">
              İzmir vize danışmanlığı hizmetlerimiz hakkında detaylı bilgi almak için hemen iletişime geçin
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%20ben%20sizinle%20karsiyakavisaconsulting.com.tr%20sitesinden%20iletisime%20geciyorum"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-5 py-2.5 md:px-8 md:py-4 bg-green-600 text-white rounded-full font-bold text-sm md:text-lg hover:bg-green-700 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-xl md:text-2xl mr-2"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center px-5 py-2.5 md:px-8 md:py-4 bg-navy-900 text-cream-100 rounded-full font-bold text-sm md:text-lg hover:bg-navy-800 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-xl md:text-2xl mr-2"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default ServicesPage;